import { useEffect, useState } from "react";
import {
  CommonHeader,
  ContentArea,
  ErrorSuccessModal,
} from "../../components/commons";
import { Label } from "reactstrap";
import DatePicker from "react-datepicker";
import moment from "moment";
import { CalenderIcon } from "../../components/Icon";
import { ToggleSwitch } from "../../components/commons";
import { connect } from "react-redux";
import { RootState } from "../../redux/rootReducers";
import {
  getMaintenanceDataAction,
  resetIsMaintenance,
  resetMaintenanceError,
  resetMaintenanceMessage,
  resetMaintenanceSuccess,
  resetStatusCode,
  scheduleMaintenanceAction,
} from "../../redux/maintenance";
import { MaintenanceTypePayload } from "../../commonTypes/maintenanceTypes";
import { GetMaintenanceTypes } from "../../redux/maintenance/maintenanceTypes";
import { resetSession } from "../../redux/auth";

type AppProps = {
  token: string | null;
  statusCode: number | null;
  success: number | null;
  error: string | null;
  message: string | null;
  maintenanceData: GetMaintenanceTypes;
  dispatchScheduleMaintenanceAction: (data: MaintenanceTypePayload) => void;
  dispatchGetMaintenanceDataAction: () => void;
  dispatchResetSession: () => void;
  dispatchResetMaintenanceErrorAction: () => void;
  dispatchResetMaintenanceSuccessAction: () => void;
  dispatchResetIsMaintaince:()=>void;
  dispatchResetMaintainceMessage:()=>void;
  dispatchResetStatusCode:()=>void
};

const ScheduleMaintenance = ({
  token,
  error,
  maintenanceData,
  statusCode,
  success,
  message,
  dispatchScheduleMaintenanceAction,
  dispatchResetMaintenanceErrorAction,
  dispatchResetMaintenanceSuccessAction,
  dispatchResetSession,
  dispatchGetMaintenanceDataAction,
  dispatchResetIsMaintaince,
  dispatchResetMaintainceMessage,
  dispatchResetStatusCode
}: AppProps) => {
  const [startDate, setStartDate] = useState<string>("");
  const [endDate, setEndDate] = useState<string>("");
  const [isMaintenance, setIsMaintenance] = useState<boolean>(false);

  useEffect(() => {
    dispatchResetMaintenanceErrorAction();
    dispatchResetMaintenanceSuccessAction();
    dispatchGetMaintenanceDataAction();
    dispatchResetIsMaintaince()
    dispatchResetMaintainceMessage()
    dispatchResetStatusCode()
  }, []);

  useEffect(() => {
    if (Object.keys(maintenanceData)?.length > 0) {
      setStartDate(maintenanceData?.start_time);
      setEndDate(maintenanceData?.end_time);
      setIsMaintenance(maintenanceData?.under_maintenance === 0 ? false : true);
    }
  }, [maintenanceData]);

  const handleStartDateChange = (date: any) => {
    setStartDate(date);
  };

  const handleEndDateChange = (date: any) => {
    setEndDate(date);
  };

  const handleToggleIsMaintenance = () => {
    setIsMaintenance(!isMaintenance);
  };

  const handleSubmitFinalData = () => {
    let finalData: MaintenanceTypePayload = {
      token,
      start_time: moment(startDate?.split(",").join("")).format(
        "DD-MM-YYYY, HH:mm:ss"
      ),
      end_time: moment(endDate?.split(",").join("")).format(
        "DD-MM-YYYY, HH:mm:ss"
      ),
      under_maintenance: isMaintenance ? 1 : 0,
    };

    dispatchScheduleMaintenanceAction(finalData);
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetMaintenanceErrorAction();
              dispatchResetIsMaintaince()
              dispatchResetMaintainceMessage()
              dispatchResetStatusCode()
            }}
          />
        );
      }
    }
    else if(success===1 && message==="Maintenance added successfully!"){
        return (
          <ErrorSuccessModal
            type="success"
            isOpen={success === 1}
            title="Success"
            message={message}
            buttonText="OK"
            onPress={() => {
              dispatchResetIsMaintaince()
              dispatchResetMaintainceMessage()
              dispatchResetStatusCode()
              dispatchGetMaintenanceDataAction()
            }}
            statusCode={statusCode}
          />
        )
    }

    return false;
  };

  return (
    <>
      <CommonHeader title="Schedule Maintenance" />
      <ContentArea>
        <div className="d-flex jutify-content-center align-items-center">
          <h6 className="mb-2">
            <strong>Schedule Maintenance:</strong>
          </h6>
          <div className="ml-3 mb-2">
            <ToggleSwitch
              handleToggleChange={handleToggleIsMaintenance}
              isChecked={isMaintenance}
            />
          </div>
        </div>
        <h6 className="mb-2 mt-4">
          <strong>Choose Start & End Date:</strong>
        </h6>
        <div className="d-flex flex-row">
          <div className="col-md-4">
            <div className="form-group">
              <div className="date-picker-wraper mr-0">
                <Label className="m-0 p-0 w-100">
                  <DatePicker
                    // dateFormat="dd-MM-yyyy"
                    selected={
                      startDate
                        ? new Date(
                            moment(
                              `${startDate}T00:00:00`,
                              "YYYY-MM-DD, HH:mm"
                            ).format("YYYY-MM-DD[T]HH:mm:ss")
                          )
                        : null
                    }
                    onChange={(e: any) => {
                      handleStartDateChange(
                        moment(e).format("YYYY-MM-DD, HH:mm")
                      );
                    }}
                    fixedHeight
                    showMonthDropdown
                    showYearDropdown
                    name="dateOfInvoice"
                    placeholderText="Start Date"
                    className="form-control"
                    showTimeSelect
                    minDate={new Date()}
                    value={startDate}
                    dateFormat="MMMM d, yyyy h:mm aa"
                    timeFormat="HH:mm"
                    timeIntervals={15}
                  />
                  <span
                    className="calender-icon"
                    style={{ right: "30px", cursor: "pointer" }}
                  >
                    <CalenderIcon />
                  </span>
                </Label>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <div className="date-picker-wraper mr-0">
                <Label className="m-0 p-0 w-100">
                  <DatePicker
                    dateFormat="dd-MM-yyyy"
                    selected={
                      endDate
                        ? new Date(
                            moment(
                              `${endDate}T00:00:00`,
                              "YYYY-MM-DD, HH:mm"
                            ).format("YYYY-MM-DD[T]HH:mm:ss")
                          )
                        : null
                    }
                    onChange={(e: any) => {
                      handleEndDateChange(
                        moment(e).format("YYYY-MM-DD, HH:mm")
                      );
                    }}
                    fixedHeight
                    showMonthDropdown
                    value={endDate}
                    showYearDropdown
                    name="dateOfInvoice"
                    placeholderText="End Date"
                    className="form-control"
                    showTimeSelect
                    timeFormat="HH:mm"
                    minDate={new Date(startDate)}
                  />
                  <span
                    className="calender-icon"
                    style={{ right: "30px", cursor: "pointer" }}
                  >
                    <CalenderIcon />
                  </span>
                </Label>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-end">
          <button className="btn btn-primary" onClick={handleSubmitFinalData}>
            Submit
          </button>
        </div>
      </ContentArea>
      {handleErrorModal()}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  success: state.maintenance.success,
  error:state.maintenance.error,
  message:state.maintenance.message,
  statusCode: state.maintenance.statusCode,
  maintenanceData: state.maintenance.maintenanceData,
  isMaintenance: state.maintenance.isMaintenance,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchScheduleMaintenanceAction: (data: MaintenanceTypePayload) =>
    dispatch(scheduleMaintenanceAction(data)),
  dispatchGetMaintenanceDataAction: () => dispatch(getMaintenanceDataAction()),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetMaintenanceErrorAction: () => dispatch(resetMaintenanceError()),
  dispatchResetMaintenanceSuccessAction: () =>
    dispatch(resetMaintenanceSuccess()),
  dispatchResetIsMaintaince:()=>dispatch(resetIsMaintenance()),
  dispatchResetMaintainceMessage:()=>dispatch(resetMaintenanceMessage()),
  dispatchResetStatusCode:()=>dispatch(resetStatusCode())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ScheduleMaintenance);
